export const Backend_LOCAL_PROXY = process.env.REACT_APP_CRF_ICF_API_URL;
export const Backend_PLPS_PROXY = process.env.REACT_APP_PLPS_API_URL;
export const Frontend_LOCAL_PROXY = process.env.REACT_APP_BASE_URL;

export const crfUtilsURL = process.env.REACT_APP_CRF_UTILS_PATH;
export const crfPlatformAgentsURL = process.env.REACT_APP_CRF_PLATFORM_AGENT_PATH;
export const crfUtilsURLToken = process.env.REACT_APP_CRF_UTILS_TOKEN;
export const crfPlatformAgentsURLToken = process.env.REACT_APP_CRF_PLATFORM_AGENT_TOKEN;

export const icfUtilsURL = process.env.REACT_APP_ICF_UTILS_PATH;
export const icfPlatformAgentsURL = process.env.REACT_APP_ICF_PLATFORM_AGENT_PATH;
export const icfUtilsURLToken = process.env.REACT_APP_ICF_UTILS_TOKEN;
export const icfPlatformAgentsURLToken = process.env.REACT_APP_ICF_PLATFORM_AGENT_TOKEN;

export const plpsUtilsURL = process.env.REACT_APP_PLPS_UTILS_PATH;
export const plpsPlatformAgentsURL = process.env.REACT_APP_PLPS_PLATFORM_AGENT_PATH;
export const plpsUtilsURLToken = process.env.REACT_APP_PLPS_UTILS_TOKEN;
export const plpsPlatformAgentsURLToken = process.env.REACT_APP_PLPS_PLATFORM_AGENT_TOKEN;

const ASK_POC_BASE_URL = process.env.REACT_APP_SKAI_API_URL;
export const ASK_URL_TOKEN = process.env.REACT_APP_SKAI_URL_TOKEN;
export const ASK_URL = `${ASK_POC_BASE_URL}${process.env.REACT_APP_SKAI_URL_PATH}`;

export const LOGGING_SERVICE_URL = process.env.REACT_APP_SERVICE_LOG_PATH;

//Constant Selectors
export const CRFstudy = "CRF";
export const ICFstudy = "ICF";
export const PLPSstudy = "PLPS";

//Utilization is only happeing at frontend
export const metadataOptions = [
  {
    attributeTag: "Region",
    attributeValue: "region",
    values: [
      { label: "Global", value: "Global" },
      { label: "United States", value: "United States" },
      { label: "North America", value: "North America" },
      { label: "Europe", value: "Europe" },
      { label: "Asia-Pacific", value: "Asia-Pacific" },
      { label: "Latin America", value: "Latin America" },
      { label: "Middle East and Africa", value: "Middle East and Africa" },
      { label: "Australia and New Zealand", value: "Australia and New Zealand" },
      { label: "Africa (Other region)", value: "Africa (Other region)" },
      { label: "Not Specified", value: "Not Specified" },
    ],
  },
  {
    attributeTag: "Study Type",
    attributeValue: "study_type",
    values: [
      { label: "Pediatric", value: "Pediatric" },
      { label: "Adolescent", value: "Adolescent" },
      { label: "Adult", value: "Adult" },
    ],
  },
  {
    attributeTag: "Disposition",
    attributeValue: "is_healthy_participants",
    values: [
      { label: "Healthy Volunteer", value: "true" },
      { label: "Patient", value: "false" },
    ],
  },
];
